let firebaseConfig = {
    apiKey: "AIzaSyDPR1dBVailo62myHYFFjYnSRmOylUs9U4",
    authDomain: "apil-slice.firebaseapp.com",
    projectId: "apil-slice",
    storageBucket: "apil-slice.appspot.com",
    messagingSenderId: "655813626114",
    appId: "1:655813626114:web:70371e426611343183da1b",
    measurementId: "G-E5RF5P7T0W"
};

export default firebaseConfig;